// source: minibook/v1/minibook.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

goog.exportSymbol('proto.minibook.v1.Asset', null, global);
goog.exportSymbol('proto.minibook.v1.CreateInstructionBackgroundRequest', null, global);
goog.exportSymbol('proto.minibook.v1.CreateInstructionBackgroundResponse', null, global);
goog.exportSymbol('proto.minibook.v1.CreateProjectRequest', null, global);
goog.exportSymbol('proto.minibook.v1.CreateProjectResponse', null, global);
goog.exportSymbol('proto.minibook.v1.CreateTemplateRequest', null, global);
goog.exportSymbol('proto.minibook.v1.CreateTemplateResponse', null, global);
goog.exportSymbol('proto.minibook.v1.DeleteInstructionBackgroundRequest', null, global);
goog.exportSymbol('proto.minibook.v1.DeleteInstructionBackgroundResponse', null, global);
goog.exportSymbol('proto.minibook.v1.ExportOptions', null, global);
goog.exportSymbol('proto.minibook.v1.ExportProjectRequest', null, global);
goog.exportSymbol('proto.minibook.v1.ExportProjectResponse', null, global);
goog.exportSymbol('proto.minibook.v1.GetActiveInstructionBackgroundRequest', null, global);
goog.exportSymbol('proto.minibook.v1.GetActiveInstructionBackgroundResponse', null, global);
goog.exportSymbol('proto.minibook.v1.GetProjectRequest', null, global);
goog.exportSymbol('proto.minibook.v1.GetProjectResponse', null, global);
goog.exportSymbol('proto.minibook.v1.GetTemplateRequest', null, global);
goog.exportSymbol('proto.minibook.v1.GetTemplateResponse', null, global);
goog.exportSymbol('proto.minibook.v1.InstructionBackground', null, global);
goog.exportSymbol('proto.minibook.v1.ListInstructionBackgroundsRequest', null, global);
goog.exportSymbol('proto.minibook.v1.ListInstructionBackgroundsResponse', null, global);
goog.exportSymbol('proto.minibook.v1.ListTemplatesRequest', null, global);
goog.exportSymbol('proto.minibook.v1.ListTemplatesResponse', null, global);
goog.exportSymbol('proto.minibook.v1.PageLayoutInfo', null, global);
goog.exportSymbol('proto.minibook.v1.Project', null, global);
goog.exportSymbol('proto.minibook.v1.ProjectPageEdit', null, global);
goog.exportSymbol('proto.minibook.v1.Template', null, global);
goog.exportSymbol('proto.minibook.v1.TemplatePage', null, global);
goog.exportSymbol('proto.minibook.v1.UpdateInstructionBackgroundRequest', null, global);
goog.exportSymbol('proto.minibook.v1.UpdateInstructionBackgroundResponse', null, global);
goog.exportSymbol('proto.minibook.v1.UpdateProjectPageRequest', null, global);
goog.exportSymbol('proto.minibook.v1.UpdateProjectPageResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.minibook.v1.ListTemplatesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.minibook.v1.ListTemplatesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.minibook.v1.ListTemplatesRequest.displayName = 'proto.minibook.v1.ListTemplatesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.minibook.v1.ListTemplatesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.minibook.v1.ListTemplatesResponse.repeatedFields_, null);
};
goog.inherits(proto.minibook.v1.ListTemplatesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.minibook.v1.ListTemplatesResponse.displayName = 'proto.minibook.v1.ListTemplatesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.minibook.v1.GetTemplateRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.minibook.v1.GetTemplateRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.minibook.v1.GetTemplateRequest.displayName = 'proto.minibook.v1.GetTemplateRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.minibook.v1.GetTemplateResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.minibook.v1.GetTemplateResponse.repeatedFields_, null);
};
goog.inherits(proto.minibook.v1.GetTemplateResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.minibook.v1.GetTemplateResponse.displayName = 'proto.minibook.v1.GetTemplateResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.minibook.v1.CreateTemplateRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.minibook.v1.CreateTemplateRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.minibook.v1.CreateTemplateRequest.displayName = 'proto.minibook.v1.CreateTemplateRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.minibook.v1.CreateTemplateResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.minibook.v1.CreateTemplateResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.minibook.v1.CreateTemplateResponse.displayName = 'proto.minibook.v1.CreateTemplateResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.minibook.v1.Template = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.minibook.v1.Template, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.minibook.v1.Template.displayName = 'proto.minibook.v1.Template';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.minibook.v1.TemplatePage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.minibook.v1.TemplatePage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.minibook.v1.TemplatePage.displayName = 'proto.minibook.v1.TemplatePage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.minibook.v1.Asset = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.minibook.v1.Asset, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.minibook.v1.Asset.displayName = 'proto.minibook.v1.Asset';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.minibook.v1.CreateProjectRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.minibook.v1.CreateProjectRequest.repeatedFields_, null);
};
goog.inherits(proto.minibook.v1.CreateProjectRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.minibook.v1.CreateProjectRequest.displayName = 'proto.minibook.v1.CreateProjectRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.minibook.v1.CreateProjectResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.minibook.v1.CreateProjectResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.minibook.v1.CreateProjectResponse.displayName = 'proto.minibook.v1.CreateProjectResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.minibook.v1.GetProjectRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.minibook.v1.GetProjectRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.minibook.v1.GetProjectRequest.displayName = 'proto.minibook.v1.GetProjectRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.minibook.v1.GetProjectResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.minibook.v1.GetProjectResponse.repeatedFields_, null);
};
goog.inherits(proto.minibook.v1.GetProjectResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.minibook.v1.GetProjectResponse.displayName = 'proto.minibook.v1.GetProjectResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.minibook.v1.PageLayoutInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.minibook.v1.PageLayoutInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.minibook.v1.PageLayoutInfo.displayName = 'proto.minibook.v1.PageLayoutInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.minibook.v1.Project = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.minibook.v1.Project.repeatedFields_, null);
};
goog.inherits(proto.minibook.v1.Project, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.minibook.v1.Project.displayName = 'proto.minibook.v1.Project';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.minibook.v1.ProjectPageEdit = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.minibook.v1.ProjectPageEdit, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.minibook.v1.ProjectPageEdit.displayName = 'proto.minibook.v1.ProjectPageEdit';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.minibook.v1.UpdateProjectPageRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.minibook.v1.UpdateProjectPageRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.minibook.v1.UpdateProjectPageRequest.displayName = 'proto.minibook.v1.UpdateProjectPageRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.minibook.v1.UpdateProjectPageResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.minibook.v1.UpdateProjectPageResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.minibook.v1.UpdateProjectPageResponse.displayName = 'proto.minibook.v1.UpdateProjectPageResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.minibook.v1.ExportProjectRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.minibook.v1.ExportProjectRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.minibook.v1.ExportProjectRequest.displayName = 'proto.minibook.v1.ExportProjectRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.minibook.v1.ExportOptions = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.minibook.v1.ExportOptions, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.minibook.v1.ExportOptions.displayName = 'proto.minibook.v1.ExportOptions';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.minibook.v1.ExportProjectResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.minibook.v1.ExportProjectResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.minibook.v1.ExportProjectResponse.displayName = 'proto.minibook.v1.ExportProjectResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.minibook.v1.ListInstructionBackgroundsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.minibook.v1.ListInstructionBackgroundsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.minibook.v1.ListInstructionBackgroundsRequest.displayName = 'proto.minibook.v1.ListInstructionBackgroundsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.minibook.v1.ListInstructionBackgroundsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.minibook.v1.ListInstructionBackgroundsResponse.repeatedFields_, null);
};
goog.inherits(proto.minibook.v1.ListInstructionBackgroundsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.minibook.v1.ListInstructionBackgroundsResponse.displayName = 'proto.minibook.v1.ListInstructionBackgroundsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.minibook.v1.InstructionBackground = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.minibook.v1.InstructionBackground, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.minibook.v1.InstructionBackground.displayName = 'proto.minibook.v1.InstructionBackground';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.minibook.v1.CreateInstructionBackgroundRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.minibook.v1.CreateInstructionBackgroundRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.minibook.v1.CreateInstructionBackgroundRequest.displayName = 'proto.minibook.v1.CreateInstructionBackgroundRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.minibook.v1.CreateInstructionBackgroundResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.minibook.v1.CreateInstructionBackgroundResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.minibook.v1.CreateInstructionBackgroundResponse.displayName = 'proto.minibook.v1.CreateInstructionBackgroundResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.minibook.v1.UpdateInstructionBackgroundRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.minibook.v1.UpdateInstructionBackgroundRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.minibook.v1.UpdateInstructionBackgroundRequest.displayName = 'proto.minibook.v1.UpdateInstructionBackgroundRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.minibook.v1.UpdateInstructionBackgroundResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.minibook.v1.UpdateInstructionBackgroundResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.minibook.v1.UpdateInstructionBackgroundResponse.displayName = 'proto.minibook.v1.UpdateInstructionBackgroundResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.minibook.v1.DeleteInstructionBackgroundRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.minibook.v1.DeleteInstructionBackgroundRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.minibook.v1.DeleteInstructionBackgroundRequest.displayName = 'proto.minibook.v1.DeleteInstructionBackgroundRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.minibook.v1.DeleteInstructionBackgroundResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.minibook.v1.DeleteInstructionBackgroundResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.minibook.v1.DeleteInstructionBackgroundResponse.displayName = 'proto.minibook.v1.DeleteInstructionBackgroundResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.minibook.v1.GetActiveInstructionBackgroundRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.minibook.v1.GetActiveInstructionBackgroundRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.minibook.v1.GetActiveInstructionBackgroundRequest.displayName = 'proto.minibook.v1.GetActiveInstructionBackgroundRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.minibook.v1.GetActiveInstructionBackgroundResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.minibook.v1.GetActiveInstructionBackgroundResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.minibook.v1.GetActiveInstructionBackgroundResponse.displayName = 'proto.minibook.v1.GetActiveInstructionBackgroundResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.minibook.v1.ListTemplatesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.minibook.v1.ListTemplatesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.minibook.v1.ListTemplatesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.ListTemplatesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.minibook.v1.ListTemplatesRequest}
 */
proto.minibook.v1.ListTemplatesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.minibook.v1.ListTemplatesRequest;
  return proto.minibook.v1.ListTemplatesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.minibook.v1.ListTemplatesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.minibook.v1.ListTemplatesRequest}
 */
proto.minibook.v1.ListTemplatesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.minibook.v1.ListTemplatesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.minibook.v1.ListTemplatesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.minibook.v1.ListTemplatesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.ListTemplatesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.minibook.v1.ListTemplatesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.minibook.v1.ListTemplatesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.minibook.v1.ListTemplatesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.minibook.v1.ListTemplatesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.ListTemplatesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
templatesList: jspb.Message.toObjectList(msg.getTemplatesList(),
    proto.minibook.v1.Template.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.minibook.v1.ListTemplatesResponse}
 */
proto.minibook.v1.ListTemplatesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.minibook.v1.ListTemplatesResponse;
  return proto.minibook.v1.ListTemplatesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.minibook.v1.ListTemplatesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.minibook.v1.ListTemplatesResponse}
 */
proto.minibook.v1.ListTemplatesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.minibook.v1.Template;
      reader.readMessage(value,proto.minibook.v1.Template.deserializeBinaryFromReader);
      msg.addTemplates(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.minibook.v1.ListTemplatesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.minibook.v1.ListTemplatesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.minibook.v1.ListTemplatesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.ListTemplatesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTemplatesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.minibook.v1.Template.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Template templates = 1;
 * @return {!Array<!proto.minibook.v1.Template>}
 */
proto.minibook.v1.ListTemplatesResponse.prototype.getTemplatesList = function() {
  return /** @type{!Array<!proto.minibook.v1.Template>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.minibook.v1.Template, 1));
};


/**
 * @param {!Array<!proto.minibook.v1.Template>} value
 * @return {!proto.minibook.v1.ListTemplatesResponse} returns this
*/
proto.minibook.v1.ListTemplatesResponse.prototype.setTemplatesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.minibook.v1.Template=} opt_value
 * @param {number=} opt_index
 * @return {!proto.minibook.v1.Template}
 */
proto.minibook.v1.ListTemplatesResponse.prototype.addTemplates = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.minibook.v1.Template, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.minibook.v1.ListTemplatesResponse} returns this
 */
proto.minibook.v1.ListTemplatesResponse.prototype.clearTemplatesList = function() {
  return this.setTemplatesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.minibook.v1.GetTemplateRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.minibook.v1.GetTemplateRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.minibook.v1.GetTemplateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.GetTemplateRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.minibook.v1.GetTemplateRequest}
 */
proto.minibook.v1.GetTemplateRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.minibook.v1.GetTemplateRequest;
  return proto.minibook.v1.GetTemplateRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.minibook.v1.GetTemplateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.minibook.v1.GetTemplateRequest}
 */
proto.minibook.v1.GetTemplateRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.minibook.v1.GetTemplateRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.minibook.v1.GetTemplateRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.minibook.v1.GetTemplateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.GetTemplateRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.minibook.v1.GetTemplateRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.minibook.v1.GetTemplateRequest} returns this
 */
proto.minibook.v1.GetTemplateRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.minibook.v1.GetTemplateResponse.repeatedFields_ = [2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.minibook.v1.GetTemplateResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.minibook.v1.GetTemplateResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.minibook.v1.GetTemplateResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.GetTemplateResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
template: (f = msg.getTemplate()) && proto.minibook.v1.Template.toObject(includeInstance, f),
templatePagesList: jspb.Message.toObjectList(msg.getTemplatePagesList(),
    proto.minibook.v1.TemplatePage.toObject, includeInstance),
backgroundAssetsList: jspb.Message.toObjectList(msg.getBackgroundAssetsList(),
    proto.minibook.v1.Asset.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.minibook.v1.GetTemplateResponse}
 */
proto.minibook.v1.GetTemplateResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.minibook.v1.GetTemplateResponse;
  return proto.minibook.v1.GetTemplateResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.minibook.v1.GetTemplateResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.minibook.v1.GetTemplateResponse}
 */
proto.minibook.v1.GetTemplateResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.minibook.v1.Template;
      reader.readMessage(value,proto.minibook.v1.Template.deserializeBinaryFromReader);
      msg.setTemplate(value);
      break;
    case 2:
      var value = new proto.minibook.v1.TemplatePage;
      reader.readMessage(value,proto.minibook.v1.TemplatePage.deserializeBinaryFromReader);
      msg.addTemplatePages(value);
      break;
    case 3:
      var value = new proto.minibook.v1.Asset;
      reader.readMessage(value,proto.minibook.v1.Asset.deserializeBinaryFromReader);
      msg.addBackgroundAssets(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.minibook.v1.GetTemplateResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.minibook.v1.GetTemplateResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.minibook.v1.GetTemplateResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.GetTemplateResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTemplate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.minibook.v1.Template.serializeBinaryToWriter
    );
  }
  f = message.getTemplatePagesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.minibook.v1.TemplatePage.serializeBinaryToWriter
    );
  }
  f = message.getBackgroundAssetsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.minibook.v1.Asset.serializeBinaryToWriter
    );
  }
};


/**
 * optional Template template = 1;
 * @return {?proto.minibook.v1.Template}
 */
proto.minibook.v1.GetTemplateResponse.prototype.getTemplate = function() {
  return /** @type{?proto.minibook.v1.Template} */ (
    jspb.Message.getWrapperField(this, proto.minibook.v1.Template, 1));
};


/**
 * @param {?proto.minibook.v1.Template|undefined} value
 * @return {!proto.minibook.v1.GetTemplateResponse} returns this
*/
proto.minibook.v1.GetTemplateResponse.prototype.setTemplate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.minibook.v1.GetTemplateResponse} returns this
 */
proto.minibook.v1.GetTemplateResponse.prototype.clearTemplate = function() {
  return this.setTemplate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.minibook.v1.GetTemplateResponse.prototype.hasTemplate = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated TemplatePage template_pages = 2;
 * @return {!Array<!proto.minibook.v1.TemplatePage>}
 */
proto.minibook.v1.GetTemplateResponse.prototype.getTemplatePagesList = function() {
  return /** @type{!Array<!proto.minibook.v1.TemplatePage>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.minibook.v1.TemplatePage, 2));
};


/**
 * @param {!Array<!proto.minibook.v1.TemplatePage>} value
 * @return {!proto.minibook.v1.GetTemplateResponse} returns this
*/
proto.minibook.v1.GetTemplateResponse.prototype.setTemplatePagesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.minibook.v1.TemplatePage=} opt_value
 * @param {number=} opt_index
 * @return {!proto.minibook.v1.TemplatePage}
 */
proto.minibook.v1.GetTemplateResponse.prototype.addTemplatePages = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.minibook.v1.TemplatePage, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.minibook.v1.GetTemplateResponse} returns this
 */
proto.minibook.v1.GetTemplateResponse.prototype.clearTemplatePagesList = function() {
  return this.setTemplatePagesList([]);
};


/**
 * repeated Asset background_assets = 3;
 * @return {!Array<!proto.minibook.v1.Asset>}
 */
proto.minibook.v1.GetTemplateResponse.prototype.getBackgroundAssetsList = function() {
  return /** @type{!Array<!proto.minibook.v1.Asset>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.minibook.v1.Asset, 3));
};


/**
 * @param {!Array<!proto.minibook.v1.Asset>} value
 * @return {!proto.minibook.v1.GetTemplateResponse} returns this
*/
proto.minibook.v1.GetTemplateResponse.prototype.setBackgroundAssetsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.minibook.v1.Asset=} opt_value
 * @param {number=} opt_index
 * @return {!proto.minibook.v1.Asset}
 */
proto.minibook.v1.GetTemplateResponse.prototype.addBackgroundAssets = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.minibook.v1.Asset, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.minibook.v1.GetTemplateResponse} returns this
 */
proto.minibook.v1.GetTemplateResponse.prototype.clearBackgroundAssetsList = function() {
  return this.setBackgroundAssetsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.minibook.v1.CreateTemplateRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.minibook.v1.CreateTemplateRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.minibook.v1.CreateTemplateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.CreateTemplateRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
slug: jspb.Message.getFieldWithDefault(msg, 1, ""),
title: jspb.Message.getFieldWithDefault(msg, 2, ""),
paperSize: jspb.Message.getFieldWithDefault(msg, 3, ""),
pageCount: jspb.Message.getFieldWithDefault(msg, 4, 0),
sheetCount: jspb.Message.getFieldWithDefault(msg, 5, 0),
status: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.minibook.v1.CreateTemplateRequest}
 */
proto.minibook.v1.CreateTemplateRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.minibook.v1.CreateTemplateRequest;
  return proto.minibook.v1.CreateTemplateRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.minibook.v1.CreateTemplateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.minibook.v1.CreateTemplateRequest}
 */
proto.minibook.v1.CreateTemplateRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlug(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaperSize(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageCount(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSheetCount(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.minibook.v1.CreateTemplateRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.minibook.v1.CreateTemplateRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.minibook.v1.CreateTemplateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.CreateTemplateRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSlug();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPaperSize();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPageCount();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getSheetCount();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string slug = 1;
 * @return {string}
 */
proto.minibook.v1.CreateTemplateRequest.prototype.getSlug = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.minibook.v1.CreateTemplateRequest} returns this
 */
proto.minibook.v1.CreateTemplateRequest.prototype.setSlug = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.minibook.v1.CreateTemplateRequest.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.minibook.v1.CreateTemplateRequest} returns this
 */
proto.minibook.v1.CreateTemplateRequest.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string paper_size = 3;
 * @return {string}
 */
proto.minibook.v1.CreateTemplateRequest.prototype.getPaperSize = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.minibook.v1.CreateTemplateRequest} returns this
 */
proto.minibook.v1.CreateTemplateRequest.prototype.setPaperSize = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 page_count = 4;
 * @return {number}
 */
proto.minibook.v1.CreateTemplateRequest.prototype.getPageCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.minibook.v1.CreateTemplateRequest} returns this
 */
proto.minibook.v1.CreateTemplateRequest.prototype.setPageCount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 sheet_count = 5;
 * @return {number}
 */
proto.minibook.v1.CreateTemplateRequest.prototype.getSheetCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.minibook.v1.CreateTemplateRequest} returns this
 */
proto.minibook.v1.CreateTemplateRequest.prototype.setSheetCount = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string status = 6;
 * @return {string}
 */
proto.minibook.v1.CreateTemplateRequest.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.minibook.v1.CreateTemplateRequest} returns this
 */
proto.minibook.v1.CreateTemplateRequest.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.minibook.v1.CreateTemplateResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.minibook.v1.CreateTemplateResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.minibook.v1.CreateTemplateResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.CreateTemplateResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.minibook.v1.CreateTemplateResponse}
 */
proto.minibook.v1.CreateTemplateResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.minibook.v1.CreateTemplateResponse;
  return proto.minibook.v1.CreateTemplateResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.minibook.v1.CreateTemplateResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.minibook.v1.CreateTemplateResponse}
 */
proto.minibook.v1.CreateTemplateResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.minibook.v1.CreateTemplateResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.minibook.v1.CreateTemplateResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.minibook.v1.CreateTemplateResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.CreateTemplateResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.minibook.v1.CreateTemplateResponse.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.minibook.v1.CreateTemplateResponse} returns this
 */
proto.minibook.v1.CreateTemplateResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.minibook.v1.Template.prototype.toObject = function(opt_includeInstance) {
  return proto.minibook.v1.Template.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.minibook.v1.Template} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.Template.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
slug: jspb.Message.getFieldWithDefault(msg, 2, ""),
title: jspb.Message.getFieldWithDefault(msg, 3, ""),
paperSize: jspb.Message.getFieldWithDefault(msg, 4, ""),
pageCount: jspb.Message.getFieldWithDefault(msg, 5, 0),
sheetCount: jspb.Message.getFieldWithDefault(msg, 6, 0),
status: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.minibook.v1.Template}
 */
proto.minibook.v1.Template.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.minibook.v1.Template;
  return proto.minibook.v1.Template.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.minibook.v1.Template} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.minibook.v1.Template}
 */
proto.minibook.v1.Template.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlug(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaperSize(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageCount(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSheetCount(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.minibook.v1.Template.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.minibook.v1.Template.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.minibook.v1.Template} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.Template.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSlug();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPaperSize();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPageCount();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getSheetCount();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.minibook.v1.Template.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.minibook.v1.Template} returns this
 */
proto.minibook.v1.Template.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string slug = 2;
 * @return {string}
 */
proto.minibook.v1.Template.prototype.getSlug = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.minibook.v1.Template} returns this
 */
proto.minibook.v1.Template.prototype.setSlug = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string title = 3;
 * @return {string}
 */
proto.minibook.v1.Template.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.minibook.v1.Template} returns this
 */
proto.minibook.v1.Template.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string paper_size = 4;
 * @return {string}
 */
proto.minibook.v1.Template.prototype.getPaperSize = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.minibook.v1.Template} returns this
 */
proto.minibook.v1.Template.prototype.setPaperSize = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 page_count = 5;
 * @return {number}
 */
proto.minibook.v1.Template.prototype.getPageCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.minibook.v1.Template} returns this
 */
proto.minibook.v1.Template.prototype.setPageCount = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 sheet_count = 6;
 * @return {number}
 */
proto.minibook.v1.Template.prototype.getSheetCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.minibook.v1.Template} returns this
 */
proto.minibook.v1.Template.prototype.setSheetCount = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string status = 7;
 * @return {string}
 */
proto.minibook.v1.Template.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.minibook.v1.Template} returns this
 */
proto.minibook.v1.Template.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.minibook.v1.TemplatePage.prototype.toObject = function(opt_includeInstance) {
  return proto.minibook.v1.TemplatePage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.minibook.v1.TemplatePage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.TemplatePage.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
templateId: jspb.Message.getFieldWithDefault(msg, 2, 0),
logicalPage: jspb.Message.getFieldWithDefault(msg, 3, 0),
defaultBackgroundAssetId: jspb.Message.getFieldWithDefault(msg, 4, 0),
renderLabel: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.minibook.v1.TemplatePage}
 */
proto.minibook.v1.TemplatePage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.minibook.v1.TemplatePage;
  return proto.minibook.v1.TemplatePage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.minibook.v1.TemplatePage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.minibook.v1.TemplatePage}
 */
proto.minibook.v1.TemplatePage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTemplateId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLogicalPage(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDefaultBackgroundAssetId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setRenderLabel(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.minibook.v1.TemplatePage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.minibook.v1.TemplatePage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.minibook.v1.TemplatePage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.TemplatePage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getTemplateId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getLogicalPage();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getDefaultBackgroundAssetId();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getRenderLabel();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.minibook.v1.TemplatePage.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.minibook.v1.TemplatePage} returns this
 */
proto.minibook.v1.TemplatePage.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 template_id = 2;
 * @return {number}
 */
proto.minibook.v1.TemplatePage.prototype.getTemplateId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.minibook.v1.TemplatePage} returns this
 */
proto.minibook.v1.TemplatePage.prototype.setTemplateId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 logical_page = 3;
 * @return {number}
 */
proto.minibook.v1.TemplatePage.prototype.getLogicalPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.minibook.v1.TemplatePage} returns this
 */
proto.minibook.v1.TemplatePage.prototype.setLogicalPage = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 default_background_asset_id = 4;
 * @return {number}
 */
proto.minibook.v1.TemplatePage.prototype.getDefaultBackgroundAssetId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.minibook.v1.TemplatePage} returns this
 */
proto.minibook.v1.TemplatePage.prototype.setDefaultBackgroundAssetId = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string render_label = 5;
 * @return {string}
 */
proto.minibook.v1.TemplatePage.prototype.getRenderLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.minibook.v1.TemplatePage} returns this
 */
proto.minibook.v1.TemplatePage.prototype.setRenderLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.minibook.v1.Asset.prototype.toObject = function(opt_includeInstance) {
  return proto.minibook.v1.Asset.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.minibook.v1.Asset} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.Asset.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
type: jspb.Message.getFieldWithDefault(msg, 2, ""),
title: jspb.Message.getFieldWithDefault(msg, 3, ""),
urlPng: jspb.Message.getFieldWithDefault(msg, 4, ""),
urlSvg: jspb.Message.getFieldWithDefault(msg, 5, ""),
widthPx: jspb.Message.getFieldWithDefault(msg, 6, 0),
heightPx: jspb.Message.getFieldWithDefault(msg, 7, 0),
status: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.minibook.v1.Asset}
 */
proto.minibook.v1.Asset.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.minibook.v1.Asset;
  return proto.minibook.v1.Asset.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.minibook.v1.Asset} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.minibook.v1.Asset}
 */
proto.minibook.v1.Asset.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrlPng(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrlSvg(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWidthPx(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHeightPx(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.minibook.v1.Asset.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.minibook.v1.Asset.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.minibook.v1.Asset} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.Asset.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUrlPng();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getUrlSvg();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getWidthPx();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getHeightPx();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.minibook.v1.Asset.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.minibook.v1.Asset} returns this
 */
proto.minibook.v1.Asset.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string type = 2;
 * @return {string}
 */
proto.minibook.v1.Asset.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.minibook.v1.Asset} returns this
 */
proto.minibook.v1.Asset.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string title = 3;
 * @return {string}
 */
proto.minibook.v1.Asset.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.minibook.v1.Asset} returns this
 */
proto.minibook.v1.Asset.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string url_png = 4;
 * @return {string}
 */
proto.minibook.v1.Asset.prototype.getUrlPng = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.minibook.v1.Asset} returns this
 */
proto.minibook.v1.Asset.prototype.setUrlPng = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string url_svg = 5;
 * @return {string}
 */
proto.minibook.v1.Asset.prototype.getUrlSvg = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.minibook.v1.Asset} returns this
 */
proto.minibook.v1.Asset.prototype.setUrlSvg = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int32 width_px = 6;
 * @return {number}
 */
proto.minibook.v1.Asset.prototype.getWidthPx = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.minibook.v1.Asset} returns this
 */
proto.minibook.v1.Asset.prototype.setWidthPx = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 height_px = 7;
 * @return {number}
 */
proto.minibook.v1.Asset.prototype.getHeightPx = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.minibook.v1.Asset} returns this
 */
proto.minibook.v1.Asset.prototype.setHeightPx = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string status = 8;
 * @return {string}
 */
proto.minibook.v1.Asset.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.minibook.v1.Asset} returns this
 */
proto.minibook.v1.Asset.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.minibook.v1.CreateProjectRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.minibook.v1.CreateProjectRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.minibook.v1.CreateProjectRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.minibook.v1.CreateProjectRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.CreateProjectRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
templateId: jspb.Message.getFieldWithDefault(msg, 1, 0),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
selectedPagesList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.minibook.v1.CreateProjectRequest}
 */
proto.minibook.v1.CreateProjectRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.minibook.v1.CreateProjectRequest;
  return proto.minibook.v1.CreateProjectRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.minibook.v1.CreateProjectRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.minibook.v1.CreateProjectRequest}
 */
proto.minibook.v1.CreateProjectRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTemplateId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt32() : [reader.readInt32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addSelectedPages(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.minibook.v1.CreateProjectRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.minibook.v1.CreateProjectRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.minibook.v1.CreateProjectRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.CreateProjectRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTemplateId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSelectedPagesList();
  if (f.length > 0) {
    writer.writePackedInt32(
      3,
      f
    );
  }
};


/**
 * optional int32 template_id = 1;
 * @return {number}
 */
proto.minibook.v1.CreateProjectRequest.prototype.getTemplateId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.minibook.v1.CreateProjectRequest} returns this
 */
proto.minibook.v1.CreateProjectRequest.prototype.setTemplateId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.minibook.v1.CreateProjectRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.minibook.v1.CreateProjectRequest} returns this
 */
proto.minibook.v1.CreateProjectRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated int32 selected_pages = 3;
 * @return {!Array<number>}
 */
proto.minibook.v1.CreateProjectRequest.prototype.getSelectedPagesList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.minibook.v1.CreateProjectRequest} returns this
 */
proto.minibook.v1.CreateProjectRequest.prototype.setSelectedPagesList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.minibook.v1.CreateProjectRequest} returns this
 */
proto.minibook.v1.CreateProjectRequest.prototype.addSelectedPages = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.minibook.v1.CreateProjectRequest} returns this
 */
proto.minibook.v1.CreateProjectRequest.prototype.clearSelectedPagesList = function() {
  return this.setSelectedPagesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.minibook.v1.CreateProjectResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.minibook.v1.CreateProjectResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.minibook.v1.CreateProjectResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.CreateProjectResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.minibook.v1.CreateProjectResponse}
 */
proto.minibook.v1.CreateProjectResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.minibook.v1.CreateProjectResponse;
  return proto.minibook.v1.CreateProjectResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.minibook.v1.CreateProjectResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.minibook.v1.CreateProjectResponse}
 */
proto.minibook.v1.CreateProjectResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.minibook.v1.CreateProjectResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.minibook.v1.CreateProjectResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.minibook.v1.CreateProjectResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.CreateProjectResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.minibook.v1.CreateProjectResponse.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.minibook.v1.CreateProjectResponse} returns this
 */
proto.minibook.v1.CreateProjectResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.minibook.v1.GetProjectRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.minibook.v1.GetProjectRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.minibook.v1.GetProjectRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.GetProjectRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.minibook.v1.GetProjectRequest}
 */
proto.minibook.v1.GetProjectRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.minibook.v1.GetProjectRequest;
  return proto.minibook.v1.GetProjectRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.minibook.v1.GetProjectRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.minibook.v1.GetProjectRequest}
 */
proto.minibook.v1.GetProjectRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.minibook.v1.GetProjectRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.minibook.v1.GetProjectRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.minibook.v1.GetProjectRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.GetProjectRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.minibook.v1.GetProjectRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.minibook.v1.GetProjectRequest} returns this
 */
proto.minibook.v1.GetProjectRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.minibook.v1.GetProjectResponse.repeatedFields_ = [2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.minibook.v1.GetProjectResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.minibook.v1.GetProjectResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.minibook.v1.GetProjectResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.GetProjectResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
project: (f = msg.getProject()) && proto.minibook.v1.Project.toObject(includeInstance, f),
pageEditsList: jspb.Message.toObjectList(msg.getPageEditsList(),
    proto.minibook.v1.ProjectPageEdit.toObject, includeInstance),
pageLayoutList: jspb.Message.toObjectList(msg.getPageLayoutList(),
    proto.minibook.v1.PageLayoutInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.minibook.v1.GetProjectResponse}
 */
proto.minibook.v1.GetProjectResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.minibook.v1.GetProjectResponse;
  return proto.minibook.v1.GetProjectResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.minibook.v1.GetProjectResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.minibook.v1.GetProjectResponse}
 */
proto.minibook.v1.GetProjectResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.minibook.v1.Project;
      reader.readMessage(value,proto.minibook.v1.Project.deserializeBinaryFromReader);
      msg.setProject(value);
      break;
    case 2:
      var value = new proto.minibook.v1.ProjectPageEdit;
      reader.readMessage(value,proto.minibook.v1.ProjectPageEdit.deserializeBinaryFromReader);
      msg.addPageEdits(value);
      break;
    case 3:
      var value = new proto.minibook.v1.PageLayoutInfo;
      reader.readMessage(value,proto.minibook.v1.PageLayoutInfo.deserializeBinaryFromReader);
      msg.addPageLayout(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.minibook.v1.GetProjectResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.minibook.v1.GetProjectResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.minibook.v1.GetProjectResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.GetProjectResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProject();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.minibook.v1.Project.serializeBinaryToWriter
    );
  }
  f = message.getPageEditsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.minibook.v1.ProjectPageEdit.serializeBinaryToWriter
    );
  }
  f = message.getPageLayoutList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.minibook.v1.PageLayoutInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional Project project = 1;
 * @return {?proto.minibook.v1.Project}
 */
proto.minibook.v1.GetProjectResponse.prototype.getProject = function() {
  return /** @type{?proto.minibook.v1.Project} */ (
    jspb.Message.getWrapperField(this, proto.minibook.v1.Project, 1));
};


/**
 * @param {?proto.minibook.v1.Project|undefined} value
 * @return {!proto.minibook.v1.GetProjectResponse} returns this
*/
proto.minibook.v1.GetProjectResponse.prototype.setProject = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.minibook.v1.GetProjectResponse} returns this
 */
proto.minibook.v1.GetProjectResponse.prototype.clearProject = function() {
  return this.setProject(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.minibook.v1.GetProjectResponse.prototype.hasProject = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated ProjectPageEdit page_edits = 2;
 * @return {!Array<!proto.minibook.v1.ProjectPageEdit>}
 */
proto.minibook.v1.GetProjectResponse.prototype.getPageEditsList = function() {
  return /** @type{!Array<!proto.minibook.v1.ProjectPageEdit>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.minibook.v1.ProjectPageEdit, 2));
};


/**
 * @param {!Array<!proto.minibook.v1.ProjectPageEdit>} value
 * @return {!proto.minibook.v1.GetProjectResponse} returns this
*/
proto.minibook.v1.GetProjectResponse.prototype.setPageEditsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.minibook.v1.ProjectPageEdit=} opt_value
 * @param {number=} opt_index
 * @return {!proto.minibook.v1.ProjectPageEdit}
 */
proto.minibook.v1.GetProjectResponse.prototype.addPageEdits = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.minibook.v1.ProjectPageEdit, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.minibook.v1.GetProjectResponse} returns this
 */
proto.minibook.v1.GetProjectResponse.prototype.clearPageEditsList = function() {
  return this.setPageEditsList([]);
};


/**
 * repeated PageLayoutInfo page_layout = 3;
 * @return {!Array<!proto.minibook.v1.PageLayoutInfo>}
 */
proto.minibook.v1.GetProjectResponse.prototype.getPageLayoutList = function() {
  return /** @type{!Array<!proto.minibook.v1.PageLayoutInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.minibook.v1.PageLayoutInfo, 3));
};


/**
 * @param {!Array<!proto.minibook.v1.PageLayoutInfo>} value
 * @return {!proto.minibook.v1.GetProjectResponse} returns this
*/
proto.minibook.v1.GetProjectResponse.prototype.setPageLayoutList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.minibook.v1.PageLayoutInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.minibook.v1.PageLayoutInfo}
 */
proto.minibook.v1.GetProjectResponse.prototype.addPageLayout = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.minibook.v1.PageLayoutInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.minibook.v1.GetProjectResponse} returns this
 */
proto.minibook.v1.GetProjectResponse.prototype.clearPageLayoutList = function() {
  return this.setPageLayoutList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.minibook.v1.PageLayoutInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.minibook.v1.PageLayoutInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.minibook.v1.PageLayoutInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.PageLayoutInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
logicalPage: jspb.Message.getFieldWithDefault(msg, 1, 0),
renderLabel: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.minibook.v1.PageLayoutInfo}
 */
proto.minibook.v1.PageLayoutInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.minibook.v1.PageLayoutInfo;
  return proto.minibook.v1.PageLayoutInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.minibook.v1.PageLayoutInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.minibook.v1.PageLayoutInfo}
 */
proto.minibook.v1.PageLayoutInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLogicalPage(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRenderLabel(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.minibook.v1.PageLayoutInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.minibook.v1.PageLayoutInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.minibook.v1.PageLayoutInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.PageLayoutInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLogicalPage();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getRenderLabel();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 logical_page = 1;
 * @return {number}
 */
proto.minibook.v1.PageLayoutInfo.prototype.getLogicalPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.minibook.v1.PageLayoutInfo} returns this
 */
proto.minibook.v1.PageLayoutInfo.prototype.setLogicalPage = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string render_label = 2;
 * @return {string}
 */
proto.minibook.v1.PageLayoutInfo.prototype.getRenderLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.minibook.v1.PageLayoutInfo} returns this
 */
proto.minibook.v1.PageLayoutInfo.prototype.setRenderLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.minibook.v1.Project.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.minibook.v1.Project.prototype.toObject = function(opt_includeInstance) {
  return proto.minibook.v1.Project.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.minibook.v1.Project} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.Project.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
templateId: jspb.Message.getFieldWithDefault(msg, 2, 0),
name: jspb.Message.getFieldWithDefault(msg, 3, ""),
selectedPagesList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.minibook.v1.Project}
 */
proto.minibook.v1.Project.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.minibook.v1.Project;
  return proto.minibook.v1.Project.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.minibook.v1.Project} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.minibook.v1.Project}
 */
proto.minibook.v1.Project.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTemplateId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt32() : [reader.readInt32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addSelectedPages(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.minibook.v1.Project.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.minibook.v1.Project.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.minibook.v1.Project} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.Project.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getTemplateId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSelectedPagesList();
  if (f.length > 0) {
    writer.writePackedInt32(
      4,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.minibook.v1.Project.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.minibook.v1.Project} returns this
 */
proto.minibook.v1.Project.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 template_id = 2;
 * @return {number}
 */
proto.minibook.v1.Project.prototype.getTemplateId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.minibook.v1.Project} returns this
 */
proto.minibook.v1.Project.prototype.setTemplateId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.minibook.v1.Project.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.minibook.v1.Project} returns this
 */
proto.minibook.v1.Project.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated int32 selected_pages = 4;
 * @return {!Array<number>}
 */
proto.minibook.v1.Project.prototype.getSelectedPagesList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.minibook.v1.Project} returns this
 */
proto.minibook.v1.Project.prototype.setSelectedPagesList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.minibook.v1.Project} returns this
 */
proto.minibook.v1.Project.prototype.addSelectedPages = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.minibook.v1.Project} returns this
 */
proto.minibook.v1.Project.prototype.clearSelectedPagesList = function() {
  return this.setSelectedPagesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.minibook.v1.ProjectPageEdit.prototype.toObject = function(opt_includeInstance) {
  return proto.minibook.v1.ProjectPageEdit.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.minibook.v1.ProjectPageEdit} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.ProjectPageEdit.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, 0),
logicalPage: jspb.Message.getFieldWithDefault(msg, 2, 0),
backgroundAssetId: jspb.Message.getFieldWithDefault(msg, 3, 0),
editJson: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.minibook.v1.ProjectPageEdit}
 */
proto.minibook.v1.ProjectPageEdit.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.minibook.v1.ProjectPageEdit;
  return proto.minibook.v1.ProjectPageEdit.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.minibook.v1.ProjectPageEdit} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.minibook.v1.ProjectPageEdit}
 */
proto.minibook.v1.ProjectPageEdit.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLogicalPage(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBackgroundAssetId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setEditJson(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.minibook.v1.ProjectPageEdit.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.minibook.v1.ProjectPageEdit.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.minibook.v1.ProjectPageEdit} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.ProjectPageEdit.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getLogicalPage();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getBackgroundAssetId();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getEditJson();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional int32 project_id = 1;
 * @return {number}
 */
proto.minibook.v1.ProjectPageEdit.prototype.getProjectId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.minibook.v1.ProjectPageEdit} returns this
 */
proto.minibook.v1.ProjectPageEdit.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 logical_page = 2;
 * @return {number}
 */
proto.minibook.v1.ProjectPageEdit.prototype.getLogicalPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.minibook.v1.ProjectPageEdit} returns this
 */
proto.minibook.v1.ProjectPageEdit.prototype.setLogicalPage = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 background_asset_id = 3;
 * @return {number}
 */
proto.minibook.v1.ProjectPageEdit.prototype.getBackgroundAssetId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.minibook.v1.ProjectPageEdit} returns this
 */
proto.minibook.v1.ProjectPageEdit.prototype.setBackgroundAssetId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string edit_json = 4;
 * @return {string}
 */
proto.minibook.v1.ProjectPageEdit.prototype.getEditJson = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.minibook.v1.ProjectPageEdit} returns this
 */
proto.minibook.v1.ProjectPageEdit.prototype.setEditJson = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.minibook.v1.UpdateProjectPageRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.minibook.v1.UpdateProjectPageRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.minibook.v1.UpdateProjectPageRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.UpdateProjectPageRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, 0),
logicalPage: jspb.Message.getFieldWithDefault(msg, 2, 0),
backgroundAssetId: jspb.Message.getFieldWithDefault(msg, 3, 0),
editJson: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.minibook.v1.UpdateProjectPageRequest}
 */
proto.minibook.v1.UpdateProjectPageRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.minibook.v1.UpdateProjectPageRequest;
  return proto.minibook.v1.UpdateProjectPageRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.minibook.v1.UpdateProjectPageRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.minibook.v1.UpdateProjectPageRequest}
 */
proto.minibook.v1.UpdateProjectPageRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLogicalPage(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBackgroundAssetId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setEditJson(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.minibook.v1.UpdateProjectPageRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.minibook.v1.UpdateProjectPageRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.minibook.v1.UpdateProjectPageRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.UpdateProjectPageRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getLogicalPage();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getBackgroundAssetId();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getEditJson();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional int32 project_id = 1;
 * @return {number}
 */
proto.minibook.v1.UpdateProjectPageRequest.prototype.getProjectId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.minibook.v1.UpdateProjectPageRequest} returns this
 */
proto.minibook.v1.UpdateProjectPageRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 logical_page = 2;
 * @return {number}
 */
proto.minibook.v1.UpdateProjectPageRequest.prototype.getLogicalPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.minibook.v1.UpdateProjectPageRequest} returns this
 */
proto.minibook.v1.UpdateProjectPageRequest.prototype.setLogicalPage = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 background_asset_id = 3;
 * @return {number}
 */
proto.minibook.v1.UpdateProjectPageRequest.prototype.getBackgroundAssetId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.minibook.v1.UpdateProjectPageRequest} returns this
 */
proto.minibook.v1.UpdateProjectPageRequest.prototype.setBackgroundAssetId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string edit_json = 4;
 * @return {string}
 */
proto.minibook.v1.UpdateProjectPageRequest.prototype.getEditJson = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.minibook.v1.UpdateProjectPageRequest} returns this
 */
proto.minibook.v1.UpdateProjectPageRequest.prototype.setEditJson = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.minibook.v1.UpdateProjectPageResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.minibook.v1.UpdateProjectPageResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.minibook.v1.UpdateProjectPageResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.UpdateProjectPageResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.minibook.v1.UpdateProjectPageResponse}
 */
proto.minibook.v1.UpdateProjectPageResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.minibook.v1.UpdateProjectPageResponse;
  return proto.minibook.v1.UpdateProjectPageResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.minibook.v1.UpdateProjectPageResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.minibook.v1.UpdateProjectPageResponse}
 */
proto.minibook.v1.UpdateProjectPageResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.minibook.v1.UpdateProjectPageResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.minibook.v1.UpdateProjectPageResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.minibook.v1.UpdateProjectPageResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.UpdateProjectPageResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.minibook.v1.ExportProjectRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.minibook.v1.ExportProjectRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.minibook.v1.ExportProjectRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.ExportProjectRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, 0),
options: (f = msg.getOptions()) && proto.minibook.v1.ExportOptions.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.minibook.v1.ExportProjectRequest}
 */
proto.minibook.v1.ExportProjectRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.minibook.v1.ExportProjectRequest;
  return proto.minibook.v1.ExportProjectRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.minibook.v1.ExportProjectRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.minibook.v1.ExportProjectRequest}
 */
proto.minibook.v1.ExportProjectRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setProjectId(value);
      break;
    case 2:
      var value = new proto.minibook.v1.ExportOptions;
      reader.readMessage(value,proto.minibook.v1.ExportOptions.deserializeBinaryFromReader);
      msg.setOptions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.minibook.v1.ExportProjectRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.minibook.v1.ExportProjectRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.minibook.v1.ExportProjectRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.ExportProjectRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getOptions();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.minibook.v1.ExportOptions.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 project_id = 1;
 * @return {number}
 */
proto.minibook.v1.ExportProjectRequest.prototype.getProjectId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.minibook.v1.ExportProjectRequest} returns this
 */
proto.minibook.v1.ExportProjectRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional ExportOptions options = 2;
 * @return {?proto.minibook.v1.ExportOptions}
 */
proto.minibook.v1.ExportProjectRequest.prototype.getOptions = function() {
  return /** @type{?proto.minibook.v1.ExportOptions} */ (
    jspb.Message.getWrapperField(this, proto.minibook.v1.ExportOptions, 2));
};


/**
 * @param {?proto.minibook.v1.ExportOptions|undefined} value
 * @return {!proto.minibook.v1.ExportProjectRequest} returns this
*/
proto.minibook.v1.ExportProjectRequest.prototype.setOptions = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.minibook.v1.ExportProjectRequest} returns this
 */
proto.minibook.v1.ExportProjectRequest.prototype.clearOptions = function() {
  return this.setOptions(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.minibook.v1.ExportProjectRequest.prototype.hasOptions = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.minibook.v1.ExportOptions.prototype.toObject = function(opt_includeInstance) {
  return proto.minibook.v1.ExportOptions.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.minibook.v1.ExportOptions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.ExportOptions.toObject = function(includeInstance, msg) {
  var f, obj = {
pageLabelPosition: jspb.Message.getFieldWithDefault(msg, 1, ""),
showInstructions: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
pageWidthInches: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
pageHeightInches: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
paperSize: jspb.Message.getFieldWithDefault(msg, 5, ""),
instructionBackgroundPath: jspb.Message.getFieldWithDefault(msg, 6, ""),
instructionBgContentX: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
instructionBgContentY: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
instructionBgContentW: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0),
instructionBgContentH: jspb.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0),
includeDetailInstructions: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
foldLineColorHex: jspb.Message.getFieldWithDefault(msg, 12, ""),
outlineLineColorHex: jspb.Message.getFieldWithDefault(msg, 13, ""),
cutLineColorHex: jspb.Message.getFieldWithDefault(msg, 14, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.minibook.v1.ExportOptions}
 */
proto.minibook.v1.ExportOptions.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.minibook.v1.ExportOptions;
  return proto.minibook.v1.ExportOptions.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.minibook.v1.ExportOptions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.minibook.v1.ExportOptions}
 */
proto.minibook.v1.ExportOptions.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPageLabelPosition(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowInstructions(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setPageWidthInches(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setPageHeightInches(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaperSize(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setInstructionBackgroundPath(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setInstructionBgContentX(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setInstructionBgContentY(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setInstructionBgContentW(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setInstructionBgContentH(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeDetailInstructions(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setFoldLineColorHex(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setOutlineLineColorHex(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setCutLineColorHex(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.minibook.v1.ExportOptions.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.minibook.v1.ExportOptions.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.minibook.v1.ExportOptions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.ExportOptions.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPageLabelPosition();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getShowInstructions();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getPageWidthInches();
  if (f !== 0.0) {
    writer.writeFloat(
      3,
      f
    );
  }
  f = message.getPageHeightInches();
  if (f !== 0.0) {
    writer.writeFloat(
      4,
      f
    );
  }
  f = message.getPaperSize();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getInstructionBackgroundPath();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getInstructionBgContentX();
  if (f !== 0.0) {
    writer.writeFloat(
      7,
      f
    );
  }
  f = message.getInstructionBgContentY();
  if (f !== 0.0) {
    writer.writeFloat(
      8,
      f
    );
  }
  f = message.getInstructionBgContentW();
  if (f !== 0.0) {
    writer.writeFloat(
      9,
      f
    );
  }
  f = message.getInstructionBgContentH();
  if (f !== 0.0) {
    writer.writeFloat(
      10,
      f
    );
  }
  f = message.getIncludeDetailInstructions();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getFoldLineColorHex();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getOutlineLineColorHex();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getCutLineColorHex();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
};


/**
 * optional string page_label_position = 1;
 * @return {string}
 */
proto.minibook.v1.ExportOptions.prototype.getPageLabelPosition = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.minibook.v1.ExportOptions} returns this
 */
proto.minibook.v1.ExportOptions.prototype.setPageLabelPosition = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool show_instructions = 2;
 * @return {boolean}
 */
proto.minibook.v1.ExportOptions.prototype.getShowInstructions = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.minibook.v1.ExportOptions} returns this
 */
proto.minibook.v1.ExportOptions.prototype.setShowInstructions = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional float page_width_inches = 3;
 * @return {number}
 */
proto.minibook.v1.ExportOptions.prototype.getPageWidthInches = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.minibook.v1.ExportOptions} returns this
 */
proto.minibook.v1.ExportOptions.prototype.setPageWidthInches = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional float page_height_inches = 4;
 * @return {number}
 */
proto.minibook.v1.ExportOptions.prototype.getPageHeightInches = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.minibook.v1.ExportOptions} returns this
 */
proto.minibook.v1.ExportOptions.prototype.setPageHeightInches = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional string paper_size = 5;
 * @return {string}
 */
proto.minibook.v1.ExportOptions.prototype.getPaperSize = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.minibook.v1.ExportOptions} returns this
 */
proto.minibook.v1.ExportOptions.prototype.setPaperSize = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string instruction_background_path = 6;
 * @return {string}
 */
proto.minibook.v1.ExportOptions.prototype.getInstructionBackgroundPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.minibook.v1.ExportOptions} returns this
 */
proto.minibook.v1.ExportOptions.prototype.setInstructionBackgroundPath = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional float instruction_bg_content_x = 7;
 * @return {number}
 */
proto.minibook.v1.ExportOptions.prototype.getInstructionBgContentX = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.minibook.v1.ExportOptions} returns this
 */
proto.minibook.v1.ExportOptions.prototype.setInstructionBgContentX = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional float instruction_bg_content_y = 8;
 * @return {number}
 */
proto.minibook.v1.ExportOptions.prototype.getInstructionBgContentY = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.minibook.v1.ExportOptions} returns this
 */
proto.minibook.v1.ExportOptions.prototype.setInstructionBgContentY = function(value) {
  return jspb.Message.setProto3FloatField(this, 8, value);
};


/**
 * optional float instruction_bg_content_w = 9;
 * @return {number}
 */
proto.minibook.v1.ExportOptions.prototype.getInstructionBgContentW = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.minibook.v1.ExportOptions} returns this
 */
proto.minibook.v1.ExportOptions.prototype.setInstructionBgContentW = function(value) {
  return jspb.Message.setProto3FloatField(this, 9, value);
};


/**
 * optional float instruction_bg_content_h = 10;
 * @return {number}
 */
proto.minibook.v1.ExportOptions.prototype.getInstructionBgContentH = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.minibook.v1.ExportOptions} returns this
 */
proto.minibook.v1.ExportOptions.prototype.setInstructionBgContentH = function(value) {
  return jspb.Message.setProto3FloatField(this, 10, value);
};


/**
 * optional bool include_detail_instructions = 11;
 * @return {boolean}
 */
proto.minibook.v1.ExportOptions.prototype.getIncludeDetailInstructions = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.minibook.v1.ExportOptions} returns this
 */
proto.minibook.v1.ExportOptions.prototype.setIncludeDetailInstructions = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional string fold_line_color_hex = 12;
 * @return {string}
 */
proto.minibook.v1.ExportOptions.prototype.getFoldLineColorHex = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.minibook.v1.ExportOptions} returns this
 */
proto.minibook.v1.ExportOptions.prototype.setFoldLineColorHex = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string outline_line_color_hex = 13;
 * @return {string}
 */
proto.minibook.v1.ExportOptions.prototype.getOutlineLineColorHex = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.minibook.v1.ExportOptions} returns this
 */
proto.minibook.v1.ExportOptions.prototype.setOutlineLineColorHex = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string cut_line_color_hex = 14;
 * @return {string}
 */
proto.minibook.v1.ExportOptions.prototype.getCutLineColorHex = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.minibook.v1.ExportOptions} returns this
 */
proto.minibook.v1.ExportOptions.prototype.setCutLineColorHex = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.minibook.v1.ExportProjectResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.minibook.v1.ExportProjectResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.minibook.v1.ExportProjectResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.ExportProjectResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
pdfData: msg.getPdfData_asB64(),
filename: jspb.Message.getFieldWithDefault(msg, 2, ""),
gridAdjusted: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
statusMessage: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.minibook.v1.ExportProjectResponse}
 */
proto.minibook.v1.ExportProjectResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.minibook.v1.ExportProjectResponse;
  return proto.minibook.v1.ExportProjectResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.minibook.v1.ExportProjectResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.minibook.v1.ExportProjectResponse}
 */
proto.minibook.v1.ExportProjectResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setPdfData(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilename(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setGridAdjusted(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatusMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.minibook.v1.ExportProjectResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.minibook.v1.ExportProjectResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.minibook.v1.ExportProjectResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.ExportProjectResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPdfData_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = message.getFilename();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getGridAdjusted();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getStatusMessage();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional bytes pdf_data = 1;
 * @return {!(string|Uint8Array)}
 */
proto.minibook.v1.ExportProjectResponse.prototype.getPdfData = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes pdf_data = 1;
 * This is a type-conversion wrapper around `getPdfData()`
 * @return {string}
 */
proto.minibook.v1.ExportProjectResponse.prototype.getPdfData_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getPdfData()));
};


/**
 * optional bytes pdf_data = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getPdfData()`
 * @return {!Uint8Array}
 */
proto.minibook.v1.ExportProjectResponse.prototype.getPdfData_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getPdfData()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.minibook.v1.ExportProjectResponse} returns this
 */
proto.minibook.v1.ExportProjectResponse.prototype.setPdfData = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


/**
 * optional string filename = 2;
 * @return {string}
 */
proto.minibook.v1.ExportProjectResponse.prototype.getFilename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.minibook.v1.ExportProjectResponse} returns this
 */
proto.minibook.v1.ExportProjectResponse.prototype.setFilename = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool grid_adjusted = 3;
 * @return {boolean}
 */
proto.minibook.v1.ExportProjectResponse.prototype.getGridAdjusted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.minibook.v1.ExportProjectResponse} returns this
 */
proto.minibook.v1.ExportProjectResponse.prototype.setGridAdjusted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional string status_message = 4;
 * @return {string}
 */
proto.minibook.v1.ExportProjectResponse.prototype.getStatusMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.minibook.v1.ExportProjectResponse} returns this
 */
proto.minibook.v1.ExportProjectResponse.prototype.setStatusMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.minibook.v1.ListInstructionBackgroundsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.minibook.v1.ListInstructionBackgroundsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.minibook.v1.ListInstructionBackgroundsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.ListInstructionBackgroundsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
activeOnly: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
isDetailInstruction: (f = jspb.Message.getBooleanField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.minibook.v1.ListInstructionBackgroundsRequest}
 */
proto.minibook.v1.ListInstructionBackgroundsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.minibook.v1.ListInstructionBackgroundsRequest;
  return proto.minibook.v1.ListInstructionBackgroundsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.minibook.v1.ListInstructionBackgroundsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.minibook.v1.ListInstructionBackgroundsRequest}
 */
proto.minibook.v1.ListInstructionBackgroundsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActiveOnly(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsDetailInstruction(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.minibook.v1.ListInstructionBackgroundsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.minibook.v1.ListInstructionBackgroundsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.minibook.v1.ListInstructionBackgroundsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.ListInstructionBackgroundsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getActiveOnly();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional bool active_only = 1;
 * @return {boolean}
 */
proto.minibook.v1.ListInstructionBackgroundsRequest.prototype.getActiveOnly = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.minibook.v1.ListInstructionBackgroundsRequest} returns this
 */
proto.minibook.v1.ListInstructionBackgroundsRequest.prototype.setActiveOnly = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bool is_detail_instruction = 2;
 * @return {boolean}
 */
proto.minibook.v1.ListInstructionBackgroundsRequest.prototype.getIsDetailInstruction = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.minibook.v1.ListInstructionBackgroundsRequest} returns this
 */
proto.minibook.v1.ListInstructionBackgroundsRequest.prototype.setIsDetailInstruction = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.minibook.v1.ListInstructionBackgroundsRequest} returns this
 */
proto.minibook.v1.ListInstructionBackgroundsRequest.prototype.clearIsDetailInstruction = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.minibook.v1.ListInstructionBackgroundsRequest.prototype.hasIsDetailInstruction = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.minibook.v1.ListInstructionBackgroundsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.minibook.v1.ListInstructionBackgroundsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.minibook.v1.ListInstructionBackgroundsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.minibook.v1.ListInstructionBackgroundsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.ListInstructionBackgroundsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
backgroundsList: jspb.Message.toObjectList(msg.getBackgroundsList(),
    proto.minibook.v1.InstructionBackground.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.minibook.v1.ListInstructionBackgroundsResponse}
 */
proto.minibook.v1.ListInstructionBackgroundsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.minibook.v1.ListInstructionBackgroundsResponse;
  return proto.minibook.v1.ListInstructionBackgroundsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.minibook.v1.ListInstructionBackgroundsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.minibook.v1.ListInstructionBackgroundsResponse}
 */
proto.minibook.v1.ListInstructionBackgroundsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.minibook.v1.InstructionBackground;
      reader.readMessage(value,proto.minibook.v1.InstructionBackground.deserializeBinaryFromReader);
      msg.addBackgrounds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.minibook.v1.ListInstructionBackgroundsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.minibook.v1.ListInstructionBackgroundsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.minibook.v1.ListInstructionBackgroundsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.ListInstructionBackgroundsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBackgroundsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.minibook.v1.InstructionBackground.serializeBinaryToWriter
    );
  }
};


/**
 * repeated InstructionBackground backgrounds = 1;
 * @return {!Array<!proto.minibook.v1.InstructionBackground>}
 */
proto.minibook.v1.ListInstructionBackgroundsResponse.prototype.getBackgroundsList = function() {
  return /** @type{!Array<!proto.minibook.v1.InstructionBackground>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.minibook.v1.InstructionBackground, 1));
};


/**
 * @param {!Array<!proto.minibook.v1.InstructionBackground>} value
 * @return {!proto.minibook.v1.ListInstructionBackgroundsResponse} returns this
*/
proto.minibook.v1.ListInstructionBackgroundsResponse.prototype.setBackgroundsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.minibook.v1.InstructionBackground=} opt_value
 * @param {number=} opt_index
 * @return {!proto.minibook.v1.InstructionBackground}
 */
proto.minibook.v1.ListInstructionBackgroundsResponse.prototype.addBackgrounds = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.minibook.v1.InstructionBackground, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.minibook.v1.ListInstructionBackgroundsResponse} returns this
 */
proto.minibook.v1.ListInstructionBackgroundsResponse.prototype.clearBackgroundsList = function() {
  return this.setBackgroundsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.minibook.v1.InstructionBackground.prototype.toObject = function(opt_includeInstance) {
  return proto.minibook.v1.InstructionBackground.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.minibook.v1.InstructionBackground} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.InstructionBackground.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
title: jspb.Message.getFieldWithDefault(msg, 2, ""),
url: jspb.Message.getFieldWithDefault(msg, 3, ""),
status: jspb.Message.getFieldWithDefault(msg, 4, ""),
widthPx: jspb.Message.getFieldWithDefault(msg, 5, 0),
heightPx: jspb.Message.getFieldWithDefault(msg, 6, 0),
createdAt: jspb.Message.getFieldWithDefault(msg, 7, ""),
isDetailInstruction: jspb.Message.getBooleanFieldWithDefault(msg, 8, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.minibook.v1.InstructionBackground}
 */
proto.minibook.v1.InstructionBackground.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.minibook.v1.InstructionBackground;
  return proto.minibook.v1.InstructionBackground.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.minibook.v1.InstructionBackground} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.minibook.v1.InstructionBackground}
 */
proto.minibook.v1.InstructionBackground.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWidthPx(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHeightPx(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedAt(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsDetailInstruction(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.minibook.v1.InstructionBackground.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.minibook.v1.InstructionBackground.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.minibook.v1.InstructionBackground} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.InstructionBackground.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getWidthPx();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getHeightPx();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getCreatedAt();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getIsDetailInstruction();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.minibook.v1.InstructionBackground.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.minibook.v1.InstructionBackground} returns this
 */
proto.minibook.v1.InstructionBackground.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.minibook.v1.InstructionBackground.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.minibook.v1.InstructionBackground} returns this
 */
proto.minibook.v1.InstructionBackground.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string url = 3;
 * @return {string}
 */
proto.minibook.v1.InstructionBackground.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.minibook.v1.InstructionBackground} returns this
 */
proto.minibook.v1.InstructionBackground.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string status = 4;
 * @return {string}
 */
proto.minibook.v1.InstructionBackground.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.minibook.v1.InstructionBackground} returns this
 */
proto.minibook.v1.InstructionBackground.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 width_px = 5;
 * @return {number}
 */
proto.minibook.v1.InstructionBackground.prototype.getWidthPx = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.minibook.v1.InstructionBackground} returns this
 */
proto.minibook.v1.InstructionBackground.prototype.setWidthPx = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 height_px = 6;
 * @return {number}
 */
proto.minibook.v1.InstructionBackground.prototype.getHeightPx = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.minibook.v1.InstructionBackground} returns this
 */
proto.minibook.v1.InstructionBackground.prototype.setHeightPx = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string created_at = 7;
 * @return {string}
 */
proto.minibook.v1.InstructionBackground.prototype.getCreatedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.minibook.v1.InstructionBackground} returns this
 */
proto.minibook.v1.InstructionBackground.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional bool is_detail_instruction = 8;
 * @return {boolean}
 */
proto.minibook.v1.InstructionBackground.prototype.getIsDetailInstruction = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.minibook.v1.InstructionBackground} returns this
 */
proto.minibook.v1.InstructionBackground.prototype.setIsDetailInstruction = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.minibook.v1.CreateInstructionBackgroundRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.minibook.v1.CreateInstructionBackgroundRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.minibook.v1.CreateInstructionBackgroundRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.CreateInstructionBackgroundRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
title: jspb.Message.getFieldWithDefault(msg, 1, ""),
url: jspb.Message.getFieldWithDefault(msg, 2, ""),
widthPx: jspb.Message.getFieldWithDefault(msg, 3, 0),
heightPx: jspb.Message.getFieldWithDefault(msg, 4, 0),
status: jspb.Message.getFieldWithDefault(msg, 5, ""),
isDetailInstruction: jspb.Message.getBooleanFieldWithDefault(msg, 6, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.minibook.v1.CreateInstructionBackgroundRequest}
 */
proto.minibook.v1.CreateInstructionBackgroundRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.minibook.v1.CreateInstructionBackgroundRequest;
  return proto.minibook.v1.CreateInstructionBackgroundRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.minibook.v1.CreateInstructionBackgroundRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.minibook.v1.CreateInstructionBackgroundRequest}
 */
proto.minibook.v1.CreateInstructionBackgroundRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWidthPx(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHeightPx(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsDetailInstruction(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.minibook.v1.CreateInstructionBackgroundRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.minibook.v1.CreateInstructionBackgroundRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.minibook.v1.CreateInstructionBackgroundRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.CreateInstructionBackgroundRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getWidthPx();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getHeightPx();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getIsDetailInstruction();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
};


/**
 * optional string title = 1;
 * @return {string}
 */
proto.minibook.v1.CreateInstructionBackgroundRequest.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.minibook.v1.CreateInstructionBackgroundRequest} returns this
 */
proto.minibook.v1.CreateInstructionBackgroundRequest.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string url = 2;
 * @return {string}
 */
proto.minibook.v1.CreateInstructionBackgroundRequest.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.minibook.v1.CreateInstructionBackgroundRequest} returns this
 */
proto.minibook.v1.CreateInstructionBackgroundRequest.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 width_px = 3;
 * @return {number}
 */
proto.minibook.v1.CreateInstructionBackgroundRequest.prototype.getWidthPx = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.minibook.v1.CreateInstructionBackgroundRequest} returns this
 */
proto.minibook.v1.CreateInstructionBackgroundRequest.prototype.setWidthPx = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 height_px = 4;
 * @return {number}
 */
proto.minibook.v1.CreateInstructionBackgroundRequest.prototype.getHeightPx = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.minibook.v1.CreateInstructionBackgroundRequest} returns this
 */
proto.minibook.v1.CreateInstructionBackgroundRequest.prototype.setHeightPx = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string status = 5;
 * @return {string}
 */
proto.minibook.v1.CreateInstructionBackgroundRequest.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.minibook.v1.CreateInstructionBackgroundRequest} returns this
 */
proto.minibook.v1.CreateInstructionBackgroundRequest.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional bool is_detail_instruction = 6;
 * @return {boolean}
 */
proto.minibook.v1.CreateInstructionBackgroundRequest.prototype.getIsDetailInstruction = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.minibook.v1.CreateInstructionBackgroundRequest} returns this
 */
proto.minibook.v1.CreateInstructionBackgroundRequest.prototype.setIsDetailInstruction = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.minibook.v1.CreateInstructionBackgroundResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.minibook.v1.CreateInstructionBackgroundResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.minibook.v1.CreateInstructionBackgroundResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.CreateInstructionBackgroundResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.minibook.v1.CreateInstructionBackgroundResponse}
 */
proto.minibook.v1.CreateInstructionBackgroundResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.minibook.v1.CreateInstructionBackgroundResponse;
  return proto.minibook.v1.CreateInstructionBackgroundResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.minibook.v1.CreateInstructionBackgroundResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.minibook.v1.CreateInstructionBackgroundResponse}
 */
proto.minibook.v1.CreateInstructionBackgroundResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.minibook.v1.CreateInstructionBackgroundResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.minibook.v1.CreateInstructionBackgroundResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.minibook.v1.CreateInstructionBackgroundResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.CreateInstructionBackgroundResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.minibook.v1.CreateInstructionBackgroundResponse.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.minibook.v1.CreateInstructionBackgroundResponse} returns this
 */
proto.minibook.v1.CreateInstructionBackgroundResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.minibook.v1.UpdateInstructionBackgroundRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.minibook.v1.UpdateInstructionBackgroundRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.minibook.v1.UpdateInstructionBackgroundRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.UpdateInstructionBackgroundRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
title: jspb.Message.getFieldWithDefault(msg, 2, ""),
url: jspb.Message.getFieldWithDefault(msg, 3, ""),
widthPx: jspb.Message.getFieldWithDefault(msg, 4, 0),
heightPx: jspb.Message.getFieldWithDefault(msg, 5, 0),
status: jspb.Message.getFieldWithDefault(msg, 6, ""),
isDetailInstruction: (f = jspb.Message.getBooleanField(msg, 7)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.minibook.v1.UpdateInstructionBackgroundRequest}
 */
proto.minibook.v1.UpdateInstructionBackgroundRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.minibook.v1.UpdateInstructionBackgroundRequest;
  return proto.minibook.v1.UpdateInstructionBackgroundRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.minibook.v1.UpdateInstructionBackgroundRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.minibook.v1.UpdateInstructionBackgroundRequest}
 */
proto.minibook.v1.UpdateInstructionBackgroundRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWidthPx(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHeightPx(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsDetailInstruction(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.minibook.v1.UpdateInstructionBackgroundRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.minibook.v1.UpdateInstructionBackgroundRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.minibook.v1.UpdateInstructionBackgroundRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.UpdateInstructionBackgroundRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getWidthPx();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getHeightPx();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeBool(
      7,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.minibook.v1.UpdateInstructionBackgroundRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.minibook.v1.UpdateInstructionBackgroundRequest} returns this
 */
proto.minibook.v1.UpdateInstructionBackgroundRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.minibook.v1.UpdateInstructionBackgroundRequest.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.minibook.v1.UpdateInstructionBackgroundRequest} returns this
 */
proto.minibook.v1.UpdateInstructionBackgroundRequest.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string url = 3;
 * @return {string}
 */
proto.minibook.v1.UpdateInstructionBackgroundRequest.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.minibook.v1.UpdateInstructionBackgroundRequest} returns this
 */
proto.minibook.v1.UpdateInstructionBackgroundRequest.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 width_px = 4;
 * @return {number}
 */
proto.minibook.v1.UpdateInstructionBackgroundRequest.prototype.getWidthPx = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.minibook.v1.UpdateInstructionBackgroundRequest} returns this
 */
proto.minibook.v1.UpdateInstructionBackgroundRequest.prototype.setWidthPx = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 height_px = 5;
 * @return {number}
 */
proto.minibook.v1.UpdateInstructionBackgroundRequest.prototype.getHeightPx = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.minibook.v1.UpdateInstructionBackgroundRequest} returns this
 */
proto.minibook.v1.UpdateInstructionBackgroundRequest.prototype.setHeightPx = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string status = 6;
 * @return {string}
 */
proto.minibook.v1.UpdateInstructionBackgroundRequest.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.minibook.v1.UpdateInstructionBackgroundRequest} returns this
 */
proto.minibook.v1.UpdateInstructionBackgroundRequest.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional bool is_detail_instruction = 7;
 * @return {boolean}
 */
proto.minibook.v1.UpdateInstructionBackgroundRequest.prototype.getIsDetailInstruction = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.minibook.v1.UpdateInstructionBackgroundRequest} returns this
 */
proto.minibook.v1.UpdateInstructionBackgroundRequest.prototype.setIsDetailInstruction = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.minibook.v1.UpdateInstructionBackgroundRequest} returns this
 */
proto.minibook.v1.UpdateInstructionBackgroundRequest.prototype.clearIsDetailInstruction = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.minibook.v1.UpdateInstructionBackgroundRequest.prototype.hasIsDetailInstruction = function() {
  return jspb.Message.getField(this, 7) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.minibook.v1.UpdateInstructionBackgroundResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.minibook.v1.UpdateInstructionBackgroundResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.minibook.v1.UpdateInstructionBackgroundResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.UpdateInstructionBackgroundResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.minibook.v1.UpdateInstructionBackgroundResponse}
 */
proto.minibook.v1.UpdateInstructionBackgroundResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.minibook.v1.UpdateInstructionBackgroundResponse;
  return proto.minibook.v1.UpdateInstructionBackgroundResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.minibook.v1.UpdateInstructionBackgroundResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.minibook.v1.UpdateInstructionBackgroundResponse}
 */
proto.minibook.v1.UpdateInstructionBackgroundResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.minibook.v1.UpdateInstructionBackgroundResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.minibook.v1.UpdateInstructionBackgroundResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.minibook.v1.UpdateInstructionBackgroundResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.UpdateInstructionBackgroundResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.minibook.v1.DeleteInstructionBackgroundRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.minibook.v1.DeleteInstructionBackgroundRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.minibook.v1.DeleteInstructionBackgroundRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.DeleteInstructionBackgroundRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.minibook.v1.DeleteInstructionBackgroundRequest}
 */
proto.minibook.v1.DeleteInstructionBackgroundRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.minibook.v1.DeleteInstructionBackgroundRequest;
  return proto.minibook.v1.DeleteInstructionBackgroundRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.minibook.v1.DeleteInstructionBackgroundRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.minibook.v1.DeleteInstructionBackgroundRequest}
 */
proto.minibook.v1.DeleteInstructionBackgroundRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.minibook.v1.DeleteInstructionBackgroundRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.minibook.v1.DeleteInstructionBackgroundRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.minibook.v1.DeleteInstructionBackgroundRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.DeleteInstructionBackgroundRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.minibook.v1.DeleteInstructionBackgroundRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.minibook.v1.DeleteInstructionBackgroundRequest} returns this
 */
proto.minibook.v1.DeleteInstructionBackgroundRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.minibook.v1.DeleteInstructionBackgroundResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.minibook.v1.DeleteInstructionBackgroundResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.minibook.v1.DeleteInstructionBackgroundResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.DeleteInstructionBackgroundResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.minibook.v1.DeleteInstructionBackgroundResponse}
 */
proto.minibook.v1.DeleteInstructionBackgroundResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.minibook.v1.DeleteInstructionBackgroundResponse;
  return proto.minibook.v1.DeleteInstructionBackgroundResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.minibook.v1.DeleteInstructionBackgroundResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.minibook.v1.DeleteInstructionBackgroundResponse}
 */
proto.minibook.v1.DeleteInstructionBackgroundResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.minibook.v1.DeleteInstructionBackgroundResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.minibook.v1.DeleteInstructionBackgroundResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.minibook.v1.DeleteInstructionBackgroundResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.DeleteInstructionBackgroundResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.minibook.v1.GetActiveInstructionBackgroundRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.minibook.v1.GetActiveInstructionBackgroundRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.minibook.v1.GetActiveInstructionBackgroundRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.GetActiveInstructionBackgroundRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.minibook.v1.GetActiveInstructionBackgroundRequest}
 */
proto.minibook.v1.GetActiveInstructionBackgroundRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.minibook.v1.GetActiveInstructionBackgroundRequest;
  return proto.minibook.v1.GetActiveInstructionBackgroundRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.minibook.v1.GetActiveInstructionBackgroundRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.minibook.v1.GetActiveInstructionBackgroundRequest}
 */
proto.minibook.v1.GetActiveInstructionBackgroundRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.minibook.v1.GetActiveInstructionBackgroundRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.minibook.v1.GetActiveInstructionBackgroundRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.minibook.v1.GetActiveInstructionBackgroundRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.GetActiveInstructionBackgroundRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.minibook.v1.GetActiveInstructionBackgroundResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.minibook.v1.GetActiveInstructionBackgroundResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.minibook.v1.GetActiveInstructionBackgroundResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.GetActiveInstructionBackgroundResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
background: (f = msg.getBackground()) && proto.minibook.v1.InstructionBackground.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.minibook.v1.GetActiveInstructionBackgroundResponse}
 */
proto.minibook.v1.GetActiveInstructionBackgroundResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.minibook.v1.GetActiveInstructionBackgroundResponse;
  return proto.minibook.v1.GetActiveInstructionBackgroundResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.minibook.v1.GetActiveInstructionBackgroundResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.minibook.v1.GetActiveInstructionBackgroundResponse}
 */
proto.minibook.v1.GetActiveInstructionBackgroundResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.minibook.v1.InstructionBackground;
      reader.readMessage(value,proto.minibook.v1.InstructionBackground.deserializeBinaryFromReader);
      msg.setBackground(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.minibook.v1.GetActiveInstructionBackgroundResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.minibook.v1.GetActiveInstructionBackgroundResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.minibook.v1.GetActiveInstructionBackgroundResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.minibook.v1.GetActiveInstructionBackgroundResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBackground();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.minibook.v1.InstructionBackground.serializeBinaryToWriter
    );
  }
};


/**
 * optional InstructionBackground background = 1;
 * @return {?proto.minibook.v1.InstructionBackground}
 */
proto.minibook.v1.GetActiveInstructionBackgroundResponse.prototype.getBackground = function() {
  return /** @type{?proto.minibook.v1.InstructionBackground} */ (
    jspb.Message.getWrapperField(this, proto.minibook.v1.InstructionBackground, 1));
};


/**
 * @param {?proto.minibook.v1.InstructionBackground|undefined} value
 * @return {!proto.minibook.v1.GetActiveInstructionBackgroundResponse} returns this
*/
proto.minibook.v1.GetActiveInstructionBackgroundResponse.prototype.setBackground = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.minibook.v1.GetActiveInstructionBackgroundResponse} returns this
 */
proto.minibook.v1.GetActiveInstructionBackgroundResponse.prototype.clearBackground = function() {
  return this.setBackground(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.minibook.v1.GetActiveInstructionBackgroundResponse.prototype.hasBackground = function() {
  return jspb.Message.getField(this, 1) != null;
};


goog.object.extend(exports, proto.minibook.v1);
